import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { getDuration } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/get-duration';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useCpmsBoGetDurationQuery } from '@service/cpms-bo-transaction-reports-duration-statistics.service';

import { useFilters } from '../../context/filters.context';
import * as css from '../../statistics.module.scss';

export const TransactionsDurationsCard = (): React.JSX.Element => {
  const { t } = useTranslation();

  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetDurationQuery({
    ...transformedFilters,
  });

  return (
    <Card gap={GapEnum.M} flex={1}>
      <AccentTitle
        icon="electric-car-2"
        text={t('$.statistics.transactions.duration.title')}
      />
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedPrimary])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Stack
          alignItems="center"
          gap={GapEnum.XS}
          flex={1}
          justifyContent="flex-start">
          <Text fontSize={TextFontSize.Large}>
            {t('$.statistics.transactions.duration.average')}
          </Text>
          <Text fontSize={TextFontSize.Medium} color={TextColor.Secondary}>
            {t('$.statistics.transactions.duration.by-transaction')}
          </Text>
        </Stack>
        <Text bold fontSize={TextFontSize.Large}>
          {data
            ? getDuration(new Date(0), new Date((data.average ?? 0) * 1000))
            : '-'}
        </Text>
      </Stack>
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedPrimary])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Text fontSize={TextFontSize.Large}>
          {t('$.statistics.transactions.duration.minimum')}
        </Text>
        <Text bold fontSize={TextFontSize.Large}>
          {data
            ? getDuration(new Date(0), new Date((data.minimum ?? 0) * 1000))
            : '-'}
        </Text>
      </Stack>
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedPrimary])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Text fontSize={TextFontSize.Large}>
          {t('$.statistics.transactions.duration.maximum')}
        </Text>
        <Text bold fontSize={TextFontSize.Large}>
          {data
            ? getDuration(new Date(0), new Date((data.maximum ?? 0) * 1000))
            : '-'}
        </Text>
      </Stack>
    </Card>
  );
};
